import { createFileRoute } from '@tanstack/react-router';

import { InvitationPage } from '../../pages/auth';

export const Route = createFileRoute('/auth/accept-invitation')({
  validateSearch: (search: Record<string, unknown>) => ({
    token: typeof search.token === 'string' ? search.token : '',
  }),
  component: () => <InvitationPage token={Route.useSearch().token} />,
});
